import { TemplateType } from './types/global';

// equals to parseInt(arr.join(''))
const fromArrayToNumber = (arr: number[]): number => {
  let stringNumber: string = '';
  let number: number = 0;

  arr.forEach((elm: number) => {
    stringNumber = stringNumber + elm.toString();
  });
  number = parseInt(stringNumber);
  return number;
};

const strGen = (str: string | undefined) => str || '';

const formaDate = (dateValue: string) => {
  if (dateValue) {
    const date = new Date(dateValue);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  return '';
};

const mappingTypeText: Record<TemplateType, string> = {
  ['sign']: 'SIGNATURE',
  ['power']: 'POWER',
};

export { fromArrayToNumber, strGen, formaDate, mappingTypeText };
